import React, { FC, Suspense } from 'react';

export const DefaultSuspense: FC = ({ children }) => (
  <Suspense fallback={<div>...</div>}>{children}</Suspense>
);
